import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from "react-helmet-async";
import { auth, GoogleAuthProvider, signInWithPopup } from '../config/firebaseConfig.js'; // Pastikan jalur benar
import ClipLoader from "react-spinners/ClipLoader";


const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [semester, setSemester] = useState('20251'); // Set default semester
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false); // Tambahkan state untuk loading

  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true); // Aktifkan loading saat mulai login
    setError('');

    try {
      const response = await fetch(`${process.env.REACT_APP_BASE_URL}/usersweb/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        // credentials: 'include',
        body: JSON.stringify({ phonenumber: username, password, semester }),
      });
      const result = await response.json();
      console.log(result.data)

      if (!response.ok) {
        throw new Error(result.message);
      }
      const data = result;
      console.log(data)
      const step = data.stap;
      localStorage.setItem('token', data.token);
      if (step == 1) {
        navigate("/daftar/identifikasisekolah");
      } else if (step == 2) {
        navigate("/daftar/identifikasiaksess");
      } else if (step == 3) {
           navigate("/pilihsemester");
        //  navigate("/daftar/formbiodata");
      } else {
         navigate("/pilihsemester");
      }
    } catch (err) {
      if (err.response) {
        // Server mengembalikan response tetapi dengan error (misalnya 401, 404, dll)
        console.log("Response error:", err.response.data);
        setError(err.response.data.message);
      } else if (err.request) {
        // Request dikirim, tetapi tidak ada respons dari server
        console.log("No response received:", err.request);
        setError('Server tidak merespons. Periksa Koneksi.');
      } else {
        // Terjadi error lain saat menyiapkan request
        console.log("Request error:", err.message);
        setError(err.message);
      }

    } finally {
      setLoading(false); // Matikan loading setelah selesai
    }
  };



  const provider = new GoogleAuthProvider();

  const loginGoogle = async () => {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;
    const res = await fetch(`${process.env.REACT_APP_BASE_URL}/registrasiweb/register_akun01`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ 'uid': user.uid, 'email': user.email, 'name': user.displayName }),
    });
    const data = await res.json();
    localStorage.setItem('token', data.token);
    console.log(data)
    const step = data.data.step;
    if (step == 1) {
      navigate("/daftar/identifikasisekolah");
    } else if (step == 2) {
      navigate("/daftar/identifikasiaksess");
    } else if (step == 3) {
     navigate("/pilihsemester");
    } else {
      navigate("/pilihsemester");
    }
  };


  


  return (
    <>
      <Helmet>
        <title>Login Griya Vidya</title>
      </Helmet>

      <div className="d-flex justify-content-center align-items-center min-vh-100 bg-light">
        <div className="card shadow p-4" style={{ width: "100%", maxWidth: "420px" }}>
          <div className="text-center mb-4">
            <img
              src="/assets/images/logogvfix.png"
              width={100}
              alt="Logo"
              className="img-fluid mb-2"
            />
            <h4 className="text-secondary mt-3"><b>Hi, Selamat Datang</b></h4>
            <p className="text-muted">Masukkan Nomor WhatsApp</p>
          </div>

          <form onSubmit={handleLogin}>
            <div className="form-floating mb-3">
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                className="form-control"
                id="wanumber"
                placeholder="Nomor WhatsApp"
                required
                disabled={loading}
              />
              <label htmlFor="wanumber">Nomor WhatsApp</label>
            </div>

            <div className="form-floating mb-3">
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="form-control"
                id="password"
                placeholder="Password"
                required
                disabled={loading}
              />
              <label htmlFor="password">Password</label>
            </div>



            <div className="d-flex justify-content-between align-items-center mb-3">
              <div></div>
              <a href="/lupapassword" className="text-secondary fw-semibold">
                Lupa Password?
              </a>
            </div>

            {error && <p className="text-danger text-center">{error}</p>}

            <div className="d-grid mt-3">
              <button
                type="submit"
                className="btn btn-secondary"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2"></span>
                    Logging in...
                  </>
                ) : (
                  "Sign In"
                )}
              </button>
            </div>

            <div className="d-grid mt-3">
              <button
                type="button"
                onClick={loginGoogle}
                className="btn btn-light"
                disabled={loading}
              >
                {loading ? (
                  <>
                   <ClipLoader size={50} />
                  </>
                ) : (
                  <>
                    <img
                      src="/assets/images/Google__G__logo.svg"
                      alt="Google Logo"
                      style={{ width: "20px", marginRight: "8px" }}
                    />
                    Google
                  </>
                )}
              </button>
            </div>


          </form>

          <hr />

          <div className="text-center">
            <h6>
              Belum memiliki akun? <a href="/daftar">Daftar</a>
            </h6>
          </div>
        </div>
      </div>
    </>

  );
};

export default Login;
